import { createSelector } from "reselect";
import { getByPath } from "./dataPaths";
import { computeStartPages } from "./pageNumbers";

const getRenderPdfReducer = (state) => state.RenderPdfReducer;

// Running start page for each section, derived from the per-section page counts
// reported by the paginating components after they measure their content.
export const selectSectionStartPages = createSelector(
  [(state) => state.RenderPdfReducer.pageCounts],
  (pageCounts) => computeStartPages(pageCounts)
);

export const SelectReportState = createSelector(
  [getRenderPdfReducer],
  (slice) => slice
);


const selectActiveData = (slice) =>
  slice.reportType === "trend" ? slice.trendData : slice.data;

export const SelectReportData = createSelector(
  [getRenderPdfReducer],
  (slice) => selectActiveData(slice)
);

// Look up a single editable value by dot-path. Used by EditableText to
// subscribe to just its own slice of the report data.
export const selectValueAtPath = (state, path) => {
  return getByPath(selectActiveData(state.RenderPdfReducer), path);
};


export const selectPageSlice = (state, pageContent, subKey) => {
  var data = selectActiveData(state.RenderPdfReducer);
  if (!data) return null;
  if (subKey != null) {
    return data.find(function (d) {
      return d.pageContent === pageContent && d.dimension === subKey;
    });
  }
  return data.find(function (d) {
    return d.pageContent === pageContent;
  });
};
